module.exports = __webpack_public_path__ + "static/media/13_after.a063b2eb.jpg";